'use client';

import Image from 'next/image';
import Link from 'next/link';
import {useRouter} from 'next/navigation';

import BackButton from '@/components/BackButton';
import {Button} from '@/components/ui/button';

export default function CenteredLayout(props: { children: React.ReactNode }) {
    const router = useRouter();

    return (
        <section className="relative flex h-screen flex-col">
            <header
                className="sticky top-0 flex w-screen items-center justify-between border-b bg-white p-5 md:px-11 lg:px-20 ">
                <BackButton/>

                <Link href="/">
                    <Image
                        src="/assets/svgs/motito.svg"
                        onClick={() => router.replace('/')}
                        alt="Logo"
                        width={87}
                        height={22}
                        className="min-h-6"
                    />
                </Link>

                <div className="flex items-center gap-2">
                    <Button variant="outline" size="icon" className="rounded-full">
                        <Image
                            src="/assets/svgs/Icons/Question_fill.svg"
                            alt="Logo"
                            width={16}
                            height={16}
                            className="min-h-8"
                        />
                    </Button>
                    <Button type="button" variant="outline" className="rounded-full">
                        <Link href="/sign-in">Log In</Link>
                    </Button>
                </div>
            </header>
            <div className="flex items-center justify-center overflow-y-auto pt-6">

                {props.children}

            </div>
        </section>
    );
}
